import React, { useState } from 'react';
import  '../../styles/Sidebar.css';
import  '../../styles/Dashboard.css';
import  '../../styles/Evaluations.css';
import EvaluationResult from '../../components/EvaluationResultsPage';

function EvaluationResultsPage() {
    return (
        <div className="Campaign-layout"> 
            <EvaluationResult />
        </div> 
    );
}

export default EvaluationResultsPage;
